import ApplicantFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/anonymousCardHolder/applicant/ApplicantFormHandler';
import ApplicantAddressFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/anonymousCardHolder/applicantAddress/AddressFormHandler';
import IndexFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/anonymousCardHolder/index/IndexFormHandler';
import AnonymousCardFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/anonymousCardHolder/anonymousCard/AnonymousCardFormHandler';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';


export default function AnonymousCardHolder() {
  return (
    <>
      <CC.Box mb={10}>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Porteur anonyme
        </CC.Text>
        <IndexFormHandler />
      </CC.Box>
      <CC.Tabs>
      <div style={{overflow: 'auto'}}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>Demandeur</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Addresse Demandeur</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Carte Anonyme</CC.Tab>
        </CC.TabList>
      </div>

      <CC.TabPanels>

        <CC.TabPanel>
          <ApplicantFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <ApplicantAddressFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <AnonymousCardFormHandler />
        </CC.TabPanel>

      </CC.TabPanels>
    </CC.Tabs>
    </>
  );
  
}